<template>
	<div>

		CECI EST LE DIV DOCUMENT <br> <br> <br>

		OUI OUI DOCUMENTS <br>

		<button @click="goback">Fermer</button>

	</div>
</template>

<script>
	export default {
		name:'Documents_immat',
		data() {
    		return {
    		}
  		},
  created () {
  },
  methods:{
  		goback(){
  			this.$router.go(-1);
  		}
		}
	}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Conduite/Documents_permis.vue